/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterocchumiditysetpoint3Inputs */



/**
* | output |
* | --- |
* | "Winter occupied humidity setpoint" |
*
* @param {Ahu_History_Key_Winterocchumiditysetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterocchumiditysetpoint3 = /** @type {((inputs?: Ahu_History_Key_Winterocchumiditysetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterocchumiditysetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter occupied humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne d'hygrométrie occupation hiver")
});
export { ahu_history_key_winterocchumiditysetpoint3 as "ahu_history_key_winterOccHumiditySetpoint" }